import { useState } from "#app";
export const useDirectusUser = () => useState("directus.user");
